module.exports = __webpack_public_path__ + "main/Components/HomePage/product_mockup2x.9ede6a7b02ceb90f0748e7f8f4b0e5ca.png";